import { Router } from '@/router';
import { LOGOUT_EVENT_NAME, LOGOUT_MESSAGE_CHANNEL } from '@/utils/authority';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ConfigProvider from 'antd/es/config-provider';
import enUS from 'antd/es/locale/en_US';
import { useEffect } from 'react';

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const channel = new BroadcastChannel(LOGOUT_MESSAGE_CHANNEL);

    channel.onmessage = (event) => {
      if (event.data === LOGOUT_EVENT_NAME) {
        queryClient.clear();
      }
    };

    return () => {
      channel.close();
    };
  }, []);

  return (
    <ConfigProvider locale={enUS}>
      <QueryClientProvider client={queryClient}>
        <Router />
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default App;
